module.exports = __webpack_public_path__ + "img/bg-threat-high.8ce544e2.png";